type MarkType = 'PERMANENT' | 'TEMPORARY'

const MARKS: Record<string, MarkType> = {
	PERMANENT: 'PERMANENT',
	TEMPORARY: 'TEMPORARY',
}

export const toposort = (nodes: Set<string>, deps: Record<string, Set<string>>) => {
	const marks: Record<string, MarkType> = {}
	const output: Array<string> = new Array<string>(nodes.size)
	let i = nodes.size

	const visit = (node: string) => {
		if (marks[node] === MARKS.PERMANENT) {
			return
		}
		if (marks[node] === MARKS.TEMPORARY) {
			throw new Error('Cyclic dependency')
		}
		marks[node] = MARKS.TEMPORARY
		if (deps[node]) {
			deps[node].forEach((dep) => visit(dep))
		}
		marks[node] = MARKS.PERMANENT
		--i
		output[i] = node
	}

	for (const node of nodes) {
		visit(node)
	}
	return output
}
